<div class="results" id="squirt-results" *ngIf="mediaData">
    <div class="buttons">
        <finder-button theme="reversed" (click)="toggle()">
            <finder-font-icon size="s" [name]="toggleIcon"></finder-font-icon>
        </finder-button>
        <finder-button theme="reversed" (click)="remove()">
            <finder-font-icon size="s" name="icon_close-reversed"></finder-font-icon>
        </finder-button>
    </div>
    <div class="avatar-wrapper">
        <div class="avatar squirt"></div>
    </div>
    <div class="overview" *ngIf="mediaData.totalMedia !== 0">
        <h2>Squirt the Turtle says</h2>
        <p>Yo dude! Your page is bodaciously awesome! I found <strong>{{mediaData.totalMedia}}</strong> media files:</p>
        <div class="media">
            <ul>
                <li>
                    <span class="tiny">⬤</span>
                    <a (click)="setDetails('tiny')">
                        <finder-font-icon size="s" name="terms-conditions"></finder-font-icon>
                    </a>
                    Tiny media: <strong>{{mediaData.mediaBySize.tiny}}</strong>
                </li>
                <li>
                    <span class="small">⬤</span>
                    <a (click)="setDetails('small')">
                        <finder-font-icon size="s" name="terms-conditions"></finder-font-icon>
                    </a>
                    Small media: <strong>{{mediaData.mediaBySize.small}}</strong>
                </li>
                <li>
                    <span class="medium">⬤</span>
                    <a (click)="setDetails('medium')">
                        <finder-font-icon size="s" name="terms-conditions"></finder-font-icon>
                    </a>
                    Medium media: <strong>{{mediaData.mediaBySize.medium}}</strong>
                </li>
                <li>
                    <span class="big">⬤</span>
                    <a (click)="setDetails('big')">
                        <finder-font-icon size="s" name="terms-conditions"></finder-font-icon>
                    </a>
                    Big media: <strong>{{mediaData.mediaBySize.big}}</strong>
                </li>
                <li>
                    <span class="huge">⬤</span>
                    <a (click)="setDetails('huge')">
                        <finder-font-icon size="s" name="terms-conditions"></finder-font-icon>
                    </a>
                    Huge media: <strong>{{mediaData.mediaBySize.huge}}</strong>
                </li>
                <li>
                    <span class="total">⬤</span>
                    <a (click)="setDetails('total')">
                        <finder-font-icon size="s" name="terms-conditions"></finder-font-icon>
                    </a>
                    Total media: <strong>{{mediaData.mediaBySize.total}}</strong>
                </li>
            </ul>
            <div class="details" *ngIf="mediaDetailsReadable">
                <textarea>{{mediaDetailsReadable}}</textarea>
                <div class="detail-buttons">
                    <a (click)="copy()">
                        <finder-font-icon size="s" name="ship-directory"></finder-font-icon>
                    </a>
                    <a (click)="hideDetails()">
                        <finder-font-icon size="s" name="icon_close-reversed"></finder-font-icon>
                    </a>
                    <span class="copied" [ngClass]="copiedHide">Copied!</span>
                </div>
            </div>
        </div>
    </div>
    <div class="squirt-content none" *ngIf="mediaData.totalMedia === 0">
        <h2>Squirt the Turtle says</h2>
        <p>Yo dude! I couldn't find any media files. Wanna try again?</p>
    </div>
</div>
